<template>
    <div
        class="Overlay"
        :class="{ 'Overlay--mobile': isMobile }"
        @click.stop="closeModal">
        <form
            novalidate
            autocomplete="off"
            v-if="!mapActive"
            @submit.prevent="sendEmail"
            class="Overlay-box"
            :class="{
                'Overlay-box--mobile': isMobile,
                'Overlay-box--inactive': mapActive,
                'Overlay-box--feedback': feedback,
                'Overlay-box--recommendation': recommendation
            }"
            @click.stop
        >

            <div
                class="Overlay-close"
                @click="closeModal"
                ref="modalCloseBtn">
                <hempel-icon name="close"/>
            </div>
            <div class="Overlay-title">
                <h1 v-if="recommendation">{{ translation.find.result.recommendation.title }}</h1>
                <h1 v-else-if="feedback">{{ translation.find.result.feedback.title }}</h1>
            </div>
            <div
                v-if="!recommendation"
                class="Overlay-radio">
                <hempel-radio
                    @change="selectOption('yes')"
                    :checked="yes"
                    name="Yes"
                    :label="translation.find.result.feedback.yes"/>
                <hempel-radio
                    @change="selectOption('no')"
                    :checked="no"
                    name="No"
                    :label="translation.find.result.feedback.no"/>
            </div>
            <div class="Overlay-input">
                <hempel-text
                    :label="translation.find.result.email"
                    @input="updateEmail"
                    name="Email"
                    type="email"
                    placeholder="email@email.com"/>
            </div>
            <div
                v-if="!recommendation"
                class="Overlay-textarea">
                <label for="comment">{{ translation.find.result.feedback.comment }}</label>
                <textarea
                    name="comment"
                    v-model="feedbackMessage"
                    id="comment"
                    :cols="20"
                    :rows="10"
                    :placeholder="translation.find.result.feedback.placeholder"/>

            </div>
            <div class="Overlay-action">
                <hempel-button
                    :label="translation.find.result.send"
                    primary
                />
            </div>
            <hempel-loader
                v-if="showLoader"
            />
        </form>

    </div>
</template>
<script>
import HempelButton from '@/components/shared/button/Button'
import HempelIcon from '@/components/shared/icon/Icon'
import HempelRadio from '@/components/shared/input/InputRadio'
import HempelText from '@/components/shared/input/InputText'
import HempelLoader from '@/components/shared/loader/Loader'

import axios from 'axios'

export default {
    data() {
        return {
            feedbackMessage: '',
            email: '',
            yes: false,
            no: false,
            showLoader: false
        }
    },
    name: 'HempelOverlay',
    components: {
        HempelButton,
        HempelIcon,
        HempelRadio,
        HempelText,
        HempelLoader
    },
    methods: {
        onKeyUp(e) {
            if (e.keyCode === 27) {
                this.closeModal()
            }
        },
        closeModal() {
            this.setRecommendation(false)
            this.setFeedback(false)
            this.setMap(false)
        },
        sendEmail() {
            if (!this.email) {
                return
            }
            this.showLoader = true
            const fullURL = `${window.location.origin}${this.$route.fullPath}`

            axios.post('/send', {
                type: this.recommendation ? 'recommendation' : 'feedback',
                email: this.email,
                link: fullURL,
                message: this.feedbackMessage,
                useful: this.yes ? 'Yes' : 'No',
                data: this.recommendation,
                headers: {
                    'Content-Type': 'image/png'
                }
            })

            setTimeout(() => {
                this.$refs.modalCloseBtn.click()
                this.showLoader = false
            }, 2000)
            if (this.recommendation) {
                this.dataLayerAdd({
                    type: 'calculatorEvent',
                    category: 'Paint Calculator',
                    action: 'Send recommendation to my email',
                    label: `${fullURL}`
                })
            } else {
                this.dataLayerAdd({
                    type: 'calculatorEvent',
                    category: 'Paint Calculator',
                    action: 'Was this information helpful',
                    label: this.yes ? 'Yes' : 'No'
                })
            }
        },
        updateEmail(e) {
            this.email = e.value
        },
        selectOption(type) {
            if (type === 'yes') {
                this.yes = true
                this.no = false
            } else {
                this.yes = false
                this.no = true
            }
        }
    },
    beforeMount() {
        window.addEventListener('keyup', this.onKeyUp)
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.onKeyUp)
    }
}
</script>
